var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 440,
    viewBox: "0 0 667 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H667V439H12C5.37258 439 0 433.627 0 427V12Z",
    fill: "#EDFFF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_9388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 69,
    width: 667,
    height: 371
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8872e-06 81C3.53122e-06 74.3726 5.37259 69 12 69L655 69C661.627 69 667 74.3726 667 81L667 440L12.0002 440C5.37283 440 0.000240315 434.627 0.000235959 428L7.8872e-06 81Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_9388)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.304 393.627L254.254 393.627L254.254 125.141L181.304 125.141L181.304 393.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.924 393.627L237.874 393.627L237.874 125.141L164.924 125.141L164.924 393.627Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 142.226L164.92 142.226L164.92 161.604L237.851 161.604L237.851 142.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 184.261L164.92 184.261L164.92 203.643L237.851 203.643L237.851 184.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 226.291L164.92 226.291L164.92 245.669L237.851 245.669L237.851 226.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 268.321L164.92 268.321L164.92 287.699L237.851 287.699L237.851 268.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 310.357L164.92 310.357L164.92 329.735L237.851 329.735L237.851 310.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.851 352.388L164.92 352.388L164.92 371.765L237.851 371.765L237.851 352.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6889 393.627L137.639 393.627L137.639 155.948L64.6889 155.948L64.6889 393.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3052 393.627L121.255 393.627L121.255 155.948L48.3052 155.948L48.3052 393.627Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 177.798L48.3008 177.798L48.3008 194.434L121.232 194.434L121.232 177.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 213.888L48.3008 213.888L48.3008 230.523L121.232 230.523L121.232 213.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 249.971L48.3008 249.971L48.3008 266.607L121.232 266.607L121.232 249.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 286.055L48.3008 286.055L48.3008 302.691L121.232 302.691L121.232 286.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 322.138L48.3008 322.138L48.3008 338.774L121.232 338.774L121.232 322.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.232 358.222L48.3008 358.222L48.3008 374.858L121.232 374.858L121.232 358.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.737 383.34L263.189 383.34L263.189 425.454L293.737 425.454L293.737 383.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.137 441.233C801.378 384.816 810.581 325.569 774.64 274.649C749.109 239.319 715.34 218.021 684.552 189.946L617.669 189.946L617.669 117.066L571.471 117.066L571.471 164.378L560.934 164.378L560.934 107.895L514.737 107.895L514.737 213.789L456.307 213.789L456.307 275.544L434.48 275.544L434.48 291.092L384.331 291.092L384.331 264.302L355.543 264.302L355.543 191.516L319.976 191.516L319.976 325.883L284.414 325.883L284.414 441.098L773.137 441.233Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 115.045L514.714 115.045L514.714 125.833L560.94 125.833L560.94 115.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 135.314L514.714 135.314L514.714 146.102L560.94 146.102L560.94 135.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 153.547L514.714 153.547L514.714 164.335L560.94 164.335L560.94 153.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66 153.547L571.434 153.547L571.434 164.335L617.66 164.335L617.66 153.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66 135.314L571.434 135.314L571.434 146.102L617.66 146.102L617.66 135.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66 117.108L571.434 117.108L571.434 127.896L617.66 127.896L617.66 117.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.674 171.229L514.714 171.229L514.714 182.016L617.674 182.016L617.674 171.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.674 188.915L514.714 188.915L514.714 199.702L617.674 199.702L617.674 188.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 191.524L319.995 191.524L319.995 208.179L355.87 208.179L355.87 191.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 216.296L319.995 216.296L319.995 232.95L355.87 232.95L355.87 216.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 241.062L319.995 241.062L319.995 257.717L355.87 257.717L355.87 241.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 267.024L319.995 267.024L319.995 283.679L355.87 283.679L355.87 267.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 292.183L319.995 292.183L319.995 308.838L355.87 308.838L355.87 292.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 317.339L319.995 317.339L319.995 333.994L355.87 333.994L355.87 317.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87 343.662L319.995 343.662L319.995 360.316L355.87 360.316L355.87 343.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.674 206.193L514.714 206.193L514.714 213.044L617.674 213.044L617.674 206.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.604 191.524L355.375 191.524L355.375 264.305L368.604 264.305L368.604 191.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.943 264.307L384.331 264.307L384.331 291.093L410.943 291.093L410.943 264.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66 117.108L617.66 127.901L617.669 171.234L617.669 182.026L617.669 189.951L626.84 189.951L626.84 117.966C626.428 117.675 626.016 117.394 625.604 117.108L617.655 117.108L617.66 117.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.575 107.895L560.939 107.895L560.939 164.336L566.575 164.336L566.575 107.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.689 224.411L465.849 224.43L465.857 234.845L473.697 234.826L473.689 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.336 224.411L480.496 224.431L480.504 234.845L488.344 234.826L488.336 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.655 224.411L494.815 224.431L494.824 234.845L502.663 234.826L502.655 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.231 224.411L508.391 224.431L508.399 234.845L516.239 234.826L516.231 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.063 224.411L522.223 224.431L522.231 234.846L530.071 234.826L530.063 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.06 224.411L536.22 224.43L536.228 234.847L544.068 234.827L544.06 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.706 224.411L550.866 224.43L550.874 234.847L558.714 234.828L558.706 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.026 224.411L565.186 224.43L565.194 234.847L573.034 234.827L573.026 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.601 224.411L578.761 224.43L578.769 234.847L586.609 234.827L586.601 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.433 224.411L592.593 224.43L592.601 234.847L600.441 234.827L600.433 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.856 224.411L607.017 224.43L607.025 234.848L614.864 234.829L614.856 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.499 224.411L621.66 224.431L621.668 234.848L629.508 234.829L629.499 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.818 224.411L635.979 224.431L635.987 234.848L643.826 234.829L643.818 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.394 224.411L649.554 224.43L649.562 234.848L657.402 234.829L657.394 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.231 224.411L663.392 224.431L663.4 234.848L671.239 234.829L671.231 224.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.688 242.825L465.848 242.845L465.856 253.26L473.696 253.24L473.688 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 242.825L480.495 242.845L480.503 253.26L488.343 253.24L488.335 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.654 242.825L494.814 242.845L494.823 253.26L502.662 253.24L502.654 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.23 242.825L508.39 242.845L508.398 253.26L516.238 253.24L516.23 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.063 242.825L522.223 242.845L522.231 253.26L530.071 253.24L530.063 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.059 242.825L536.219 242.845L536.227 253.261L544.067 253.242L544.059 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.705 242.825L550.865 242.845L550.873 253.261L558.713 253.242L558.705 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.025 242.825L565.185 242.845L565.193 253.261L573.033 253.242L573.025 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.6 242.825L578.76 242.845L578.768 253.261L586.608 253.242L586.6 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.433 242.825L592.593 242.845L592.601 253.261L600.441 253.242L600.433 242.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.854 242.826L607.015 242.845L607.023 253.262L614.863 253.243L614.854 242.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.498 242.826L621.659 242.845L621.667 253.262L629.506 253.243L629.498 242.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.816 242.826L635.977 242.845L635.985 253.262L643.824 253.243L643.816 242.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.391 242.826L649.551 242.845L649.559 253.262L657.399 253.243L657.391 242.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.229 242.826L663.39 242.845L663.398 253.262L671.237 253.243L671.229 242.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.688 260.964L465.848 260.983L465.856 271.398L473.696 271.378L473.688 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 260.964L480.495 260.983L480.503 271.398L488.343 271.378L488.335 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.654 260.963L494.814 260.983L494.823 271.398L502.662 271.378L502.654 260.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.23 260.964L508.39 260.983L508.398 271.398L516.238 271.378L516.23 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.063 260.964L522.223 260.983L522.231 271.398L530.071 271.378L530.063 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.059 260.964L536.219 260.983L536.227 271.4L544.067 271.38L544.059 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.705 260.964L550.865 260.983L550.873 271.4L558.713 271.38L558.705 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.025 260.963L565.185 260.983L565.193 271.399L573.033 271.38L573.025 260.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.6 260.964L578.76 260.983L578.768 271.4L586.608 271.38L586.6 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.433 260.964L592.593 260.983L592.601 271.4L600.441 271.38L600.433 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.854 260.963L607.015 260.983L607.023 271.4L614.863 271.38L614.854 260.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.498 260.964L621.659 260.983L621.667 271.4L629.506 271.381L629.498 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.816 260.963L635.977 260.983L635.985 271.4L643.824 271.381L643.816 260.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.391 260.964L649.551 260.983L649.559 271.4L657.399 271.381L657.391 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.229 260.964L663.39 260.983L663.398 271.4L671.237 271.381L671.229 260.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.689 280.23L465.849 280.265L465.857 290.668L473.697 290.633L473.689 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 280.23L480.496 280.265L480.504 290.668L488.343 290.633L488.335 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.655 280.23L494.815 280.266L494.823 290.668L502.663 290.633L502.655 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.229 280.23L508.39 280.265L508.398 290.668L516.237 290.633L516.229 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.062 280.23L522.223 280.265L522.231 290.668L530.07 290.633L530.062 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.06 280.23L536.22 280.265L536.228 290.667L544.068 290.632L544.06 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.707 280.231L550.867 280.265L550.875 290.667L558.715 290.633L558.707 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.026 280.231L565.186 280.266L565.194 290.668L573.035 290.633L573.026 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.602 280.231L578.762 280.266L578.77 290.668L586.61 290.633L586.602 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.434 280.231L592.593 280.266L592.601 290.668L600.442 290.633L600.434 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.856 280.23L607.015 280.265L607.023 290.666L614.864 290.632L614.856 280.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.5 280.231L621.659 280.265L621.667 290.667L629.508 290.632L629.5 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.818 280.231L635.978 280.265L635.986 290.667L643.826 290.632L643.818 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.394 280.231L649.553 280.265L649.561 290.667L657.402 290.632L657.394 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.231 280.231L663.39 280.265L663.398 290.667L671.239 290.632L671.231 280.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.688 298.647L465.849 298.682L465.857 309.084L473.696 309.049L473.688 298.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 298.646L480.495 298.681L480.503 309.084L488.343 309.049L488.335 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.655 298.646L494.815 298.681L494.823 309.084L502.663 309.049L502.655 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.23 298.646L508.391 298.681L508.399 309.084L516.238 309.049L516.23 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.062 298.646L522.223 298.681L522.231 309.084L530.07 309.049L530.062 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.06 298.647L536.219 298.681L536.227 309.083L544.068 309.049L544.06 298.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.706 298.646L550.866 298.68L550.874 309.082L558.714 309.048L558.706 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.025 298.646L565.185 298.681L565.193 309.083L573.034 309.048L573.025 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.601 298.646L578.761 298.681L578.769 309.083L586.609 309.048L586.601 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.434 298.646L592.593 298.681L592.601 309.083L600.442 309.048L600.434 298.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.854 298.645L607.014 298.68L607.022 309.081L614.862 309.047L614.854 298.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.498 298.645L621.657 298.679L621.665 309.081L629.506 309.046L629.498 298.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.816 298.645L635.976 298.679L635.984 309.081L643.824 309.047L643.816 298.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.39 298.645L649.55 298.679L649.558 309.081L657.398 309.047L657.39 298.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.229 298.645L663.388 298.679L663.396 309.081L671.237 309.047L671.229 298.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.689 316.778L465.849 316.813L465.857 327.215L473.697 327.18L473.689 316.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.335 316.777L480.496 316.812L480.504 327.214L488.343 327.179L488.335 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.655 316.777L494.815 316.812L494.824 327.214L502.663 327.179L502.655 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.231 316.777L508.391 316.812L508.399 327.215L516.239 327.18L516.231 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.063 316.777L522.223 316.812L522.231 327.215L530.071 327.18L530.063 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.06 316.777L536.22 316.812L536.228 327.214L544.068 327.179L544.06 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.707 316.776L550.866 316.811L550.874 327.213L558.715 327.178L558.707 316.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.026 316.777L565.186 316.811L565.194 327.213L573.034 327.179L573.026 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.602 316.777L578.761 316.811L578.769 327.213L586.61 327.179L586.602 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.434 316.777L592.594 316.811L592.602 327.213L600.442 327.179L600.434 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.855 316.777L607.014 316.811L607.022 327.213L614.863 327.178L614.855 316.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.498 316.776L621.658 316.81L621.666 327.212L629.506 327.178L629.498 316.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.817 316.776L635.976 316.811L635.984 327.212L643.825 327.178L643.817 316.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.391 316.776L649.55 316.811L649.558 327.212L657.399 327.178L657.391 316.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.229 316.776L663.389 316.811L663.397 327.212L671.237 327.178L671.229 316.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.472 349.473L410.944 349.473L410.944 442.053L592.472 442.053L592.472 349.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.825 395.763L273.297 395.763L273.297 442.053L454.825 442.053L454.825 395.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.888 360.316L423.067 360.316L423.067 377.463L456.888 377.463L456.888 360.316Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.305 360.316L466.484 360.316L466.484 377.463L500.305 377.463L500.305 360.316Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.894 360.316L509.073 360.316L509.073 377.463L542.894 377.463L542.894 360.316Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.664 360.316L550.843 360.316L550.843 377.463L584.664 377.463L584.664 360.316Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.079 184.28L327.133 184.28L327.133 191.529L328.079 191.529L328.079 184.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.979 184.28L361.033 184.28L361.033 191.529L361.979 191.529L361.979 184.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.175 362.06L175.537 362.06L175.537 441.304L300.175 441.304L300.175 362.06Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.175 351.709L175.537 351.709L175.537 377.464L300.175 377.464L300.175 351.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.424 385.097L184.018 385.105L184.024 393.628L190.43 393.619L190.424 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.392 385.097L195.986 385.105L195.993 393.628L202.399 393.619L202.392 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.094 385.097L207.688 385.105L207.695 393.628L214.101 393.619L214.094 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.191 385.097L218.785 385.105L218.791 393.628L225.197 393.62L225.191 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 385.097L230.094 385.105L230.1 393.628L236.506 393.62L236.5 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.935 385.097L241.529 385.105L241.535 393.628L247.941 393.62L247.935 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.91 385.097L253.504 385.106L253.51 393.628L259.916 393.62L259.91 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.608 385.097L265.202 385.106L265.208 393.628L271.614 393.62L271.608 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.707 385.097L276.301 385.106L276.308 393.628L282.714 393.62L282.707 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.016 385.097L287.61 385.105L287.616 393.628L294.022 393.62L294.016 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.424 400.149L184.018 400.158L184.024 408.68L190.43 408.672L190.424 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.392 400.15L195.986 400.158L195.993 408.681L202.399 408.673L202.392 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.096 400.15L207.69 400.158L207.696 408.681L214.102 408.673L214.096 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19 400.15L218.784 400.158L218.791 408.681L225.197 408.673L225.19 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 400.15L230.094 400.158L230.1 408.681L236.506 408.672L236.5 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.935 400.149L241.529 400.157L241.535 408.68L247.941 408.672L247.935 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.91 400.149L253.504 400.158L253.51 408.68L259.916 408.672L259.91 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.608 400.149L265.202 400.158L265.208 408.68L271.614 408.672L271.608 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.707 400.149L276.301 400.158L276.308 408.68L282.714 408.672L282.707 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.016 400.149L287.61 400.158L287.616 408.68L294.022 408.672L294.016 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.424 414.966L184.018 414.974L184.024 423.497L190.43 423.489L190.424 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.392 414.966L195.986 414.974L195.993 423.497L202.399 423.488L202.392 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.094 414.966L207.688 414.974L207.695 423.497L214.101 423.488L214.094 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.191 414.966L218.785 414.974L218.791 423.497L225.197 423.488L225.191 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 414.966L230.094 414.974L230.1 423.497L236.506 423.488L236.5 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.935 414.966L241.529 414.974L241.535 423.497L247.941 423.488L247.935 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.91 414.966L253.504 414.974L253.51 423.497L259.916 423.488L259.91 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.608 414.966L265.202 414.974L265.208 423.497L271.614 423.488L271.608 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.707 414.966L276.301 414.974L276.308 423.497L282.714 423.488L282.707 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.016 414.966L287.61 414.974L287.616 423.497L294.022 423.488L294.016 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.189 362.06L50.5505 362.06L50.5505 441.304L175.189 441.304L175.189 362.06Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.189 351.709L50.5505 351.709L50.5505 377.464L175.189 377.464L175.189 351.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4382 385.097L59.0322 385.105L59.0385 393.628L65.4445 393.619L65.4382 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4079 385.097L71.002 385.105L71.0083 393.628L77.4143 393.619L77.4079 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1096 385.097L82.7036 385.105L82.7099 393.628L89.1159 393.62L89.1096 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.205 385.097L93.7986 385.106L93.8049 393.628L100.211 393.62L100.205 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.514 385.097L105.108 385.106L105.114 393.628L111.52 393.62L111.514 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.955 385.097L116.549 385.105L116.555 393.628L122.961 393.62L122.955 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.925 385.097L128.519 385.106L128.525 393.628L134.931 393.62L134.925 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.625 385.097L140.219 385.106L140.226 393.628L146.632 393.62L146.625 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72 385.097L151.314 385.106L151.321 393.628L157.727 393.62L157.72 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 385.097L162.625 385.105L162.631 393.628L169.037 393.62L169.031 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4382 400.149L59.0322 400.158L59.0385 408.68L65.4445 408.672L65.4382 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.407 400.15L71.001 400.158L71.0073 408.681L77.4133 408.672L77.407 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1096 400.15L82.7036 400.158L82.7099 408.681L89.1159 408.672L89.1096 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.205 400.15L93.7986 400.158L93.8049 408.681L100.211 408.672L100.205 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.514 400.15L105.108 400.158L105.114 408.681L111.52 408.672L111.514 400.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.955 400.149L116.549 400.158L116.555 408.68L122.961 408.672L122.955 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.924 400.149L128.518 400.158L128.524 408.68L134.93 408.672L134.924 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.626 400.149L140.22 400.158L140.226 408.68L146.632 408.672L146.626 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.721 400.149L151.315 400.158L151.321 408.68L157.727 408.672L157.721 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 400.149L162.625 400.158L162.631 408.68L169.037 408.672L169.031 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4382 414.966L59.0322 414.975L59.0385 423.497L65.4445 423.489L65.4382 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4067 414.966L71.0007 414.974L71.007 423.497L77.413 423.488L77.4067 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1101 414.966L82.7041 414.974L82.7104 423.497L89.1164 423.488L89.1101 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.205 414.966L93.7986 414.974L93.8049 423.497L100.211 423.488L100.205 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.514 414.966L105.108 414.974L105.114 423.497L111.52 423.488L111.514 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.955 414.966L116.549 414.974L116.555 423.497L122.961 423.488L122.955 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.924 414.966L128.518 414.974L128.524 423.497L134.93 423.488L134.924 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.626 414.966L140.22 414.974L140.226 423.497L146.632 423.488L146.626 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.721 414.966L151.315 414.974L151.321 423.497L157.727 423.489L157.721 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 414.966L162.625 414.974L162.631 423.497L169.037 423.489L169.031 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4302 362.06L-82.2083 362.06L-82.2083 441.304L42.4302 441.304L42.4302 362.06Z",
    fill: "#2D8A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4302 351.709L-82.2083 351.709L-82.2083 377.464L42.4302 377.464L42.4302 351.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16331 385.097L-4.24268 385.106L-4.23638 393.628L2.1696 393.62L2.16331 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8667 385.097L7.46069 385.106L7.46698 393.628L13.873 393.62L13.8667 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9616 385.097L18.5557 385.106L18.562 393.628L24.9679 393.62L24.9616 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2707 385.097L29.8647 385.105L29.871 393.628L36.277 393.62L36.2707 385.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16453 400.149L-4.24146 400.158L-4.23516 408.68L2.17082 408.672L2.16453 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8667 400.149L7.46069 400.158L7.46699 408.68L13.873 408.672L13.8667 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9616 400.149L18.5557 400.158L18.562 408.68L24.9679 408.672L24.9616 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2717 400.149L29.8657 400.158L29.872 408.68L36.278 408.672L36.2717 400.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16453 414.966L-4.24146 414.974L-4.23516 423.497L2.17082 423.488L2.16453 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8667 414.966L7.46069 414.974L7.46699 423.497L13.873 423.488L13.8667 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9616 414.966L18.5557 414.974L18.562 423.497L24.9679 423.489L24.9616 414.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2717 414.966L29.8657 414.974L29.872 423.497L36.278 423.489L36.2717 414.966Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.324 440L1.977 439.959C1.977 439.959 -2.75787 428.863 -8.95923 410.537C-2.04068 408.941 17.0665 405.475 30.3791 412.012C46.8994 420.126 44.7371 430.923 65.2002 426.965C85.6597 423.008 102.537 421.347 111.7 426.965C120.863 432.58 127.588 430.349 138.985 430.314C148.433 430.287 150.05 437.528 150.324 440Z",
    fill: "#0EA35B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.421 442.457C586.709 439.797 581.547 432.896 574.678 433.809C567.195 434.803 582.944 439.681 587.766 442.477C586.694 442.492 585.774 442.406 585.098 442.17C581.872 441.036 576.355 443.214 574.587 443.977L605.278 443.977C605.065 443.249 604.511 442.065 603.083 441.202C602.58 440.896 601.564 440.856 600.258 440.951C602.082 438.828 603.352 432.038 598.272 433.784C594.558 435.059 594.568 439.209 594.934 441.664C594.147 441.784 593.344 441.909 592.551 442.02C591.022 434.326 585.616 411.778 574.663 411.175C563.557 410.568 584.082 434.557 590.915 442.231C590.042 442.336 589.198 442.411 588.416 442.452L588.421 442.457Z",
    fill: "#0EA35B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.586 352.5L243.234 288.049C232.346 269.187 226.621 247.787 226.628 225.87C226.656 157.293 282.458 101.501 351.02 101.501C384.297 101.516 415.529 114.469 439.012 137.978C462.499 161.486 475.426 192.735 475.413 225.967C475.384 294.546 419.579 350.343 351.025 350.343C351.025 350.343 351.02 350.343 351.025 350.343L350.97 350.343C330.152 350.336 309.697 345.109 291.529 335.206L225.586 352.5Z",
    fill: "#0EA35B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M442.189 134.783C417.86 110.433 385.509 97.0152 351.042 97C280.015 97 222.215 154.793 222.186 225.829C222.178 248.536 228.11 270.701 239.385 290.24L221.104 357L289.412 339.085C308.232 349.351 329.422 354.761 350.986 354.769L351.041 354.769C422.055 354.769 479.865 296.966 479.895 225.933C479.907 191.506 466.515 159.136 442.189 134.783ZM351.042 333.01L351 333.01C331.779 333 312.93 327.839 296.489 318.081L292.577 315.761L252.042 326.391L262.864 286.877L260.315 282.826C249.593 265.775 243.933 246.07 243.941 225.838C243.965 166.795 292.006 118.761 351.082 118.761C379.69 118.773 406.577 129.926 426.799 150.165C447.019 170.405 458.147 197.31 458.138 225.925C458.113 284.969 410.07 333.01 351.042 333.01Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M476 142C476 166.853 455.853 187 431 187C406.147 187 386 166.853 386 142C386 117.147 406.147 97 431 97C455.853 97 476 117.147 476 142Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431 180.622C452.397 180.622 469.742 163.277 469.742 141.88C469.742 120.483 452.397 103.138 431 103.138C409.603 103.138 392.257 120.483 392.257 141.88C392.257 163.277 409.603 180.622 431 180.622Z",
    fill: "#FFAB26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M436.347 136.534C440.872 141.059 440.81 148.312 436.378 152.775L436.347 152.806L431.264 157.889C426.785 162.367 419.486 162.367 414.992 157.889C410.513 153.41 410.513 146.111 414.992 141.617L417.797 138.812C418.541 138.068 419.827 138.564 419.858 139.618C419.904 140.966 420.152 142.299 420.586 143.6C420.741 144.034 420.633 144.53 420.307 144.856L419.315 145.848C417.192 147.971 417.13 151.426 419.222 153.565C421.346 155.735 424.832 155.735 426.971 153.596L432.054 148.513C434.193 146.374 434.177 142.934 432.054 140.811C431.775 140.532 431.496 140.315 431.279 140.16C430.969 139.943 430.768 139.587 430.752 139.199C430.721 138.393 431 137.572 431.636 136.937L433.232 135.341C433.65 134.922 434.301 134.876 434.797 135.217C435.339 135.62 435.866 136.053 436.347 136.534V136.534Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M447.009 125.872C442.53 121.394 435.231 121.394 430.737 125.872L425.654 130.955L425.623 130.986C421.191 135.45 421.129 142.702 425.654 147.227C426.134 147.708 426.646 148.142 427.203 148.529C427.684 148.87 428.35 148.823 428.769 148.405L430.365 146.809C431 146.174 431.279 145.352 431.248 144.546C431.233 144.159 431.031 143.802 430.721 143.586C430.504 143.431 430.225 143.214 429.946 142.935C427.823 140.812 427.808 137.356 429.946 135.233L435.029 130.15C437.168 128.011 440.655 128.027 442.778 130.181C444.885 132.319 444.808 135.775 442.685 137.898L441.693 138.89C441.368 139.215 441.259 139.711 441.414 140.145C441.864 141.447 442.096 142.795 442.143 144.128C442.174 145.182 443.46 145.678 444.204 144.934L447.009 142.129C451.487 137.65 451.487 130.351 447.009 125.872V125.872Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M374.663 227.113C377.491 228.883 379.893 230.998 381.869 233.46C383.94 235.822 385.589 238.772 386.818 242.307C388.15 246.225 388.859 250.204 388.943 254.245C389.122 258.187 388.477 261.906 387.01 265.401C385.638 268.798 383.343 271.829 380.126 274.495C377.004 277.062 372.856 278.929 367.683 280.096C364.908 280.827 361.648 281.425 357.904 281.888C354.16 282.351 350.797 282.613 347.815 282.675C344.065 282.85 340.169 282.931 336.127 282.919C332.182 283.001 328.326 282.697 324.559 282.005C322.913 281.558 321.694 280.766 320.9 279.628C320.2 278.391 319.69 277.006 319.37 275.473C318.967 274.615 318.756 273.753 318.738 272.888L317.03 190.925C316.973 188.231 317.459 186.152 318.488 184.687C319.61 183.124 321.078 181.986 322.892 181.275C324.703 180.467 326.763 179.991 329.07 179.847C331.374 179.606 333.777 179.46 336.279 179.408C338.203 179.368 340.127 179.327 342.051 179.287C344.069 179.149 346.089 179.107 348.111 179.161C351.288 179.191 354.565 179.411 357.942 179.822C361.413 180.135 364.7 180.836 367.802 181.926C369.255 182.377 370.808 183.019 372.462 183.85C374.113 184.586 375.432 185.521 376.418 186.655C379.555 189.381 381.884 192.605 383.405 196.326C385.02 199.95 385.772 203.688 385.66 207.54C385.546 211.295 384.563 214.925 382.711 218.428C380.955 221.93 378.273 224.825 374.663 227.113ZM350.208 265.879C353.186 265.625 356.209 265.225 359.278 264.68C362.346 264.135 364.443 263.177 365.57 261.806C366.788 260.241 367.617 258.443 368.056 256.413C368.589 254.284 368.689 252.165 368.356 250.054C368.118 247.846 367.449 245.79 366.351 243.888C365.347 241.888 364.015 240.328 362.356 239.208C360.107 237.522 357.535 236.469 354.639 236.048C351.74 235.531 348.897 235.302 346.107 235.36C344.76 235.388 343.51 235.462 342.358 235.583C341.3 235.605 340.341 235.769 339.481 236.076C338.715 236.284 338.147 236.729 337.776 237.41C337.406 238.092 337.234 239.106 337.262 240.453C337.507 242.95 337.559 245.451 337.419 247.956C337.279 250.462 337.233 252.869 337.281 255.177C337.309 256.524 337.292 258.016 337.23 259.654C337.262 261.193 337.818 262.481 338.898 263.517C339.978 264.553 341.533 265.242 343.561 265.585C345.589 265.928 347.805 266.026 350.208 265.879ZM351.65 196.555C348.666 196.521 346.163 196.525 344.143 196.567C342.217 196.511 340.681 196.688 339.535 197.096C338.482 197.407 337.728 198.145 337.271 199.309C336.908 200.375 336.798 202.014 336.94 204.224C336.978 206.052 336.968 207.881 336.91 209.711C336.946 211.442 336.982 213.174 337.019 214.906C337.059 216.83 337.714 218.26 338.985 219.195C340.253 220.035 341.804 220.532 343.635 220.687C345.563 220.839 347.536 220.798 349.552 220.563C351.664 220.327 353.487 220.048 355.02 219.727C358.471 219.078 361.093 217.868 362.884 216.099C364.77 214.231 365.821 211.562 366.038 208.093C366.332 203.756 365.116 200.798 362.388 199.219C359.755 197.541 356.175 196.653 351.65 196.555Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5a7e5c8fc4bba49fb49d3a0891147156.svg";
export { ForwardRef as ReactComponent };